import PropTypes from "prop-types";

const TONE_CLASSES = {
    primary: "bg-[#F2F2FA] text-[#5D5DF6]",
    success: "bg-[#EDFBF3] text-[#52c41a]",
    neutral: "bg-[#F5F5F5] text-[#9b9ba5]",
};

const DocumentRowIcon = ({ icon, tone = "primary" }) => (
    <div
        className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${TONE_CLASSES[tone] ?? TONE_CLASSES.primary}`}>
        {icon}
    </div>
);

DocumentRowIcon.propTypes = {
    icon: PropTypes.node.isRequired,
    tone: PropTypes.oneOf(["primary", "success", "neutral"]),
};

export default DocumentRowIcon;
